import HttpRequestRotoBrain from "../../Services/HttpRequestRotoBrain";

export const onBoardingSurvey = async (body: any) => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "POST",
      url: "/v1/onboarding/survey",
      data: body,
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};

export const onBoardingSurveyStatus = async () => {
  try {
    const response = await HttpRequestRotoBrain({
      method: "GET",
      url: "/v1/onboarding/survey/status",
    });

    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      status: false,
      errors: error,
    };
  }
};
